import Loader2 from "lucide-react/dist/esm/icons/loader-2";
import { Header } from "@/components/Header";

/**
 * Full-page loading state with subtle fade-in animation.
 * Uses CSS-only animations (opacity) for performance; respects prefers-reduced-motion.
 */
export function PageLoader() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-background animate-fade-in"
      aria-live="polite"
      aria-busy="true"
      role="status"
    >
      <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
      <span className="sr-only">Loading…</span>
    </div>
  );
}

/**
 * Page loader with header for pages that show navigation.
 */
export function PageLoaderWithHeader() {
  return (
    <div className="min-h-screen bg-background animate-fade-in">
      <Header />
      <div
        className="flex h-[calc(100vh-64px)] items-center justify-center"
        aria-live="polite"
        aria-busy="true"
        role="status"
      >
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
        <span className="sr-only">Loading…</span>
      </div>
    </div>
  );
}
